import {
  GetProgressBarDocument,
  GetProgressBarQuery,
  GetProgressBarQueryVariables,
  Scalars,
} from 'generated/graphql';
import { client } from './client';
import { getLocalesForGraphQL } from '../utils/helpers';

export async function getProgressBar(id: string, locale: string) {
  return client.query<GetProgressBarQuery, GetProgressBarQueryVariables>({
    query: GetProgressBarDocument,
    variables: {
      locales: getLocalesForGraphQL(locale),
      where: {
        id,
      },
    },
  });
}
